import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/shared/lib/utils"

const loaderVariants = cva(
    "relative inline-block",
    {
        variants: {
            size: {
                default: "w-8 h-8", // 32px
                sm: "w-4 h-4",      // 16px - comum em botões
                md: "w-8 h-8",      // 32px
                lg: "w-16 h-16",    // 64px - page loader
                xl: "w-24 h-24",    // 96px
            },
            variant: {
                default: "text-visagio-teal",
                white: "text-white",
                muted: "text-muted-foreground",
                primary: "text-primary",
                secondary: "text-secondary",
            }
        },
        defaultVariants: {
            size: "default",
            variant: "default",
        },
    }
)

export interface LoaderProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof loaderVariants> { }

function Loader({ className, size, variant, ...props }: LoaderProps) {
    // Ajusta a espessura da borda com base no tamanho
    const borderClass = size === "sm" ? "border-2" : size === "lg" || size === "xl" ? "border-4" : "border-[3px]";

    return (
        <div className={cn(loaderVariants({ size, variant, className }))} {...props}>
            {/* Círculo base (background) */}
            <div className={cn(
                "w-full h-full rounded-full opacity-20",
                borderClass,
                "border-current"
            )} />

            {/* Círculo giratório (foreground) */}
            <div className={cn(
                "absolute top-0 left-0 w-full h-full rounded-full animate-spin",
                borderClass,
                "border-current border-t-transparent"
            )} />
        </div>
    )
}

export { Loader, loaderVariants }
